import React, { Component } from 'react';
import { Button, Row, Col, Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import CompanyContext from '../../auth/CompanyContext';
import ConfirmButton from '../../components/Modal/ConfirmButton';
import { Prompt } from 'react-router-dom';

class CompanyTypes extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.state = {
            companyType: '',
            companyTypes: [],
            editCompanyTypeId: null,
            editCompanyTypeLabel: '',
            unsavedChanges: false
        }
    };

    componentDidMount = () => {
        this.getCompanyTypes();
    }

    getCompanyTypes = () => {
        fetch('/api/companies/types/', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    unsavedChanges: false,
                    companyTypes: results.data || []
                })
            })
    }

    handleSubmit = () => {
        const companyTypeLabel = this.state.companyType.trim();
        if (!companyTypeLabel) return;

        fetch('/api/companies/types/', {
            method: 'POST',
            body: JSON.stringify({ companyTypeLabel }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then((results) => {
                if (results.success) {
                    this.setState({
                        companyType: '',
                        unsavedChanges: false
                    }, () => this.getCompanyTypes())
                }
            })
    }

    handleDelete = (companyTypeId) => {
        fetch('/api/companies/types/' + companyTypeId, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(() => {
                if (this.state.editCompanyTypeId === companyTypeId) {
                    this.setState({ editCompanyTypeId: null, editCompanyTypeLabel: '', unsavedChanges: false });
                }
                this.getCompanyTypes();
            })
    }

    startEdit = (companyType) => {
        this.setState({
            editCompanyTypeId: companyType.companyTypeId,
            editCompanyTypeLabel: companyType.companyTypeLabel,
            unsavedChanges: false
        });
    }

    handleEdit = () => {
        const companyTypeLabel = this.state.editCompanyTypeLabel.trim();
        if (!this.state.editCompanyTypeId || !companyTypeLabel) return;

        fetch('/api/companies/types/' + this.state.editCompanyTypeId, {
            method: 'PUT',
            body: JSON.stringify({ companyTypeLabel }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then((results) => {
                if (results.success || results.data) {
                    this.setState({
                        editCompanyTypeId: null,
                        editCompanyTypeLabel: '',
                        unsavedChanges: false
                    }, () => this.getCompanyTypes())
                }
            })
    }

    render() {
        const companyTypes = [...this.state.companyTypes].sort((a, b) =>
            String(a.companyTypeLabel || '').localeCompare(String(b.companyTypeLabel || ''), undefined, { sensitivity: 'base' })
        );

        return (
            <Row>
                <Prompt
                    when={this.state.unsavedChanges}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                <Col>
                    <Row>
                        <Col>
                            <Label>Company Type
                                <Input
                                    type="text"
                                    name="companyType"
                                    value={this.state.companyType}
                                    onChange={(e) => this.setState({ companyType: e.target.value, unsavedChanges: true })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && this.state.companyType.trim()) {
                                            e.preventDefault();
                                            this.handleSubmit();
                                        }
                                    }}
                                ></Input>
                            </Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button
                                className="mt-4"
                                disabled={!this.state.companyType.trim()}
                                color="primary"
                                onClick={this.handleSubmit}
                            >Submit</Button>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    {companyTypes.map(companyType => (
                        <Row key={companyType.companyTypeId} className="text-left mt-3 align-items-center">
                            <Col md={6}>
                                {this.state.editCompanyTypeId === companyType.companyTypeId
                                    ? <Input
                                        type="text"
                                        value={this.state.editCompanyTypeLabel}
                                        autoFocus
                                        onChange={(e) => this.setState({ editCompanyTypeLabel: e.target.value, unsavedChanges: true })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' && this.state.editCompanyTypeLabel.trim()) {
                                                e.preventDefault();
                                                this.handleEdit();
                                            }
                                        }}
                                    />
                                    : companyType.companyTypeLabel}
                            </Col>
                            <Col md={6}>
                                {this.state.editCompanyTypeId === companyType.companyTypeId
                                    ? <Button
                                        className="mx-1"
                                        color="success"
                                        disabled={!this.state.editCompanyTypeLabel.trim()}
                                        onClick={this.handleEdit}
                                        title="Save Company Type"
                                    >
                                        <FontAwesomeIcon icon={faCheck} />
                                    </Button>
                                    : <Button
                                        className="mx-1"
                                        color="primary"
                                        onClick={() => this.startEdit(companyType)}
                                        title="Edit Company Type"
                                    >
                                        <FontAwesomeIcon icon={faEdit} />
                                    </Button>}
                                <ConfirmButton className="mx-1" color="danger" onClick={() => this.handleDelete(companyType.companyTypeId)} title="Delete Company Type">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </ConfirmButton>
                            </Col>
                        </Row>
                    ))}
                </Col>
            </Row>
        );
    }
}

export default CompanyTypes;
